import Store from "../Store";
import { isArray, map, intersection, countBy } from "lodash";
import { currentAssetSliceActions } from "../Store/Slices/CurrentAssetSlice";
import { calculateGenericScore } from "./ScoreCalculate";
import { durationCalculate, unicodeToString, audioSmartCheck } from "./Common";

let loggedInState, duration, durationStartTimeStamp;

export const checkAssetTypeAndCallFunction = (assetType, evalMode) => {
  let currentAssetState = Store.getState().currentAsset;
  duration = currentAssetState.duration;
  durationStartTimeStamp = currentAssetState.durationStartTimeStamp;
  loggedInState = Store.getState().loggedInUserInfo.userInfo;
  let numberOfAttemptes = currentAssetState.numberOfAttemptes;
  let currentAttempt = currentAssetState.currentAttempt;
  let userAnswer = currentAssetState.currentAttemptData;
  let actualAnswer = currentAssetState.assetLogObj.actualAnswer;
  switch (assetType) {
    case "MC":
    case "TF":
      return checkMCAndTFCorrectAnswer(
        userAnswer,
        actualAnswer,
        currentAttempt,
        numberOfAttemptes,
        assetType,
        evalMode
      );
      break;
    case "RTS":
    case "MATCH":
      return checkRTSAndMATCHCorrectAnswer(
        userAnswer,
        actualAnswer,
        currentAttempt,
        numberOfAttemptes,
        assetType,
        evalMode
      );
      break;
    case "JW":
      return checkJWCorrectAnswer(
        userAnswer,
        actualAnswer,
        currentAttempt,
        numberOfAttemptes,
        assetType,
        evalMode
      );
      break;
    case "DIC":
      return checkDICCorrectAnswer(
        userAnswer,
        actualAnswer,
        currentAttempt,
        numberOfAttemptes,
        assetType,
        evalMode
      );
      break;
    case "SF":
      return checkSFCorrectAnswer(
        userAnswer,
        actualAnswer,
        currentAttempt,
        numberOfAttemptes,
        assetType,
        evalMode
      );
      break;
    case "FIB":
      return checkFIBCorrectAnswer(
        userAnswer,
        actualAnswer,
        currentAttempt,
        numberOfAttemptes,
        assetType,
        evalMode
      );
      break;
    case "REC":
    case "WORD":
      return checkRECCorrectAnswer(
        userAnswer,
        actualAnswer,
        currentAttempt,
        numberOfAttemptes,
        assetType,
        evalMode
      );
      break;
    case "SB":
      return checkSBCorrectAnswer(
        userAnswer,
        actualAnswer,
        currentAttempt,
        numberOfAttemptes,
        assetType,
        evalMode
      );
      break;
    case "OO":
      return checkOOCorrectAnswer(
        userAnswer,
        actualAnswer,
        currentAttempt,
        numberOfAttemptes,
        assetType,
        evalMode
      );
      break;
    case "WS":
      return checkWSCorrectAnswer(
        userAnswer,
        actualAnswer,
        currentAttempt,
        numberOfAttemptes,
        assetType,
        evalMode
      );
      break;
    case "TFS":
      return checkTFSCorrectAnswer(
        userAnswer,
        actualAnswer,
        currentAttempt,
        numberOfAttemptes,
        assetType,
        evalMode
      );
      break;
    case "IE":
      return checkIECorrectAnswer(
        userAnswer,
        actualAnswer,
        currentAttempt,
        numberOfAttemptes,
        assetType,
        evalMode
      );
      break;
    case "NB":
      return checkNBCorrectAnswer(
        userAnswer,
        actualAnswer,
        currentAttempt,
        numberOfAttemptes,
        assetType,
        evalMode
      );
      break;
    case "THESAURUS":
    case "WORDGROUP":
      return checkTHESAURUSorWORDGROUPCorrectAnswer(
        userAnswer,
        actualAnswer,
        currentAttempt,
        numberOfAttemptes,
        assetType,
        evalMode
      );
      break;
    case "BINGO":
      return checkBINGOCorrectAnswer(
        userAnswer,
        actualAnswer,
        currentAttempt,
        numberOfAttemptes,
        assetType,
        evalMode
      );
      break;
    case "ILT":
    case "BG":
      return checkILTCorrectAnswer(
        userAnswer,
        actualAnswer,
        currentAttempt,
        numberOfAttemptes,
        assetType,
        evalMode
      );
      break;
    case "MEDIA":
      return checkMEDIACorrectAnswer(
        userAnswer,
        actualAnswer,
        currentAttempt,
        numberOfAttemptes,
        assetType,
        evalMode
      );
      break;
    case "RECADV":
      return checkRECADVCorrectAnswer(
        userAnswer,
        actualAnswer,
        currentAttempt,
        numberOfAttemptes,
        assetType,
        evalMode
      );
      break;
  }
};

const commitUserAnswerInStore = (
  userAnswer,
  score,
  currentAttempt,
  evalMode = "auto",
  assetType = null
) => {
  const serverRole = Store.getState().defs.serverRole;

  let userAnswerObj = {
    ans: userAnswer,
    score:
      serverRole && serverRole.toLowerCase() == "web_host"
        ? score
        : assetType &&
          (assetType == "REC" || assetType == "WORD" || assetType == "RECADV")
        ? 1
        : score,
    duration: durationCalculate(duration, durationStartTimeStamp),
  };

  console.log("userAnswer", userAnswer);
  console.log("assetType", assetType);
  if (
    assetType &&
    (assetType == "REC" || assetType == "WORD" || assetType == "RECADV")
  ) {
    userAnswerObj["analysis"] = Store.getState().currentAsset.smartCheck;
    if (assetType == "RECADV") {
      userAnswerObj["advResult"] = Store.getState().currentAsset.smartAdvCheck;
    }
  }

  Store.dispatch(
    currentAssetSliceActions.setAssetLogObjUseranswer({
      userAnswer: userAnswerObj,
      evalMode: evalMode,
      attempts: +currentAttempt,
    })
  );
};

export const checkMCAndTFCorrectAnswer = (
  userAnswer,
  actualAnswer,
  currentAttempt,
  numberOfAttemptes,
  assetType,
  evalMode
) => {
  let totalTrueOptionsOfUseranswer = 0;
  let totalTrueOptionsOfActualanswer = 0;
  let totalCorrectAnswer = 0;
  let totalAttemptedAns = 0;
  let score = 0;
  let genericScore = 0;
  let attempted = false;
  let optionWiseAns = new Array(actualAnswer.length);

  actualAnswer.map((val, index) => {
    if (userAnswer && userAnswer[index]) {
      totalTrueOptionsOfUseranswer++;

      if (assetType == "MC") {
        attempted = true;
        if (userAnswer[index] == val) optionWiseAns[index] = true;
        else optionWiseAns[index] = false;
      }
    }
    if (
      userAnswer &&
      assetType == "TF" &&
      userAnswer[index] != null &&
      (userAnswer[index].toString() == "true" ||
        userAnswer[index].toString() == "false")
    ) {
      totalAttemptedAns++;
    }
    if (val) {
      totalTrueOptionsOfActualanswer++;
    }
    if (userAnswer && val && assetType == "MC") {
      if (val == userAnswer[index]) {
        totalCorrectAnswer++;
      }
    }
    if (userAnswer && assetType == "TF") {
      if (val == userAnswer[index]) {
        totalCorrectAnswer++;
        optionWiseAns[index] = true;
      } else {
        optionWiseAns[index] = false;
      }
    }
  });

  let maxTrueOptions = totalTrueOptionsOfActualanswer;
  console.log("totalTrueOptionsOfActualanswer", totalTrueOptionsOfActualanswer);
  console.log("totalTrueOptionsOfUseranswer", totalTrueOptionsOfUseranswer);
  if (totalTrueOptionsOfUseranswer > totalTrueOptionsOfActualanswer) {
    maxTrueOptions = totalTrueOptionsOfUseranswer;
  }

  if (totalCorrectAnswer) {
    if (assetType == "MC")
      score = (+totalCorrectAnswer / +maxTrueOptions).toFixed(2);
    if (assetType == "TF")
      score = (+totalCorrectAnswer / +actualAnswer.length).toFixed(2);
  }

  if (assetType == "TF" && +totalAttemptedAns == +actualAnswer.length) {
    attempted = true;
  }

  if (attempted && loggedInState.rolesInfo.title.toLowerCase() == "learner") {
    genericScore = calculateGenericScore(
      currentAttempt,
      numberOfAttemptes,
      score
    ).toFixed(2);
    commitUserAnswerInStore(userAnswer, genericScore, currentAttempt);
  } else {
    genericScore = 1;
  }

  return {
    totalOptions: actualAnswer.length,
    totalCorrectAnswer,
    score,
    attempted,
    genericScore,
    evalMode,
    optionWiseAns,
  };
};

export const checkRTSAndMATCHCorrectAnswer = (
  userAnswer,
  actualAnswer,
  currentAttempt,
  numberOfAttemptes,
  assetType,
  evalMode
) => {
  let totalCorrectAnswer = 0;
  let score = 0;
  let genericScore = 0;
  let attempted = false;
  let optionWiseAns = new Array(actualAnswer.length);

  if (userAnswer !== null) {
    attempted = true;
  }

  console.log("actualAnswer", actualAnswer);
  console.log("userAnswer", userAnswer);

  actualAnswer.map((val, index) => {
    if (assetType == "RTS") {
      if (
        userAnswer &&
        userAnswer[index] &&
        val &&
        val.id == userAnswer[index].id
      ) {
        totalCorrectAnswer++;
        optionWiseAns[index] = true;
      } else {
        optionWiseAns[index] = false;
      }
    }
    if (assetType == "MATCH") {
      if (Array.isArray(userAnswer) && val == userAnswer[index]) {
        totalCorrectAnswer++;
        optionWiseAns[index] = true;
      } else {
        optionWiseAns[index] = false;
      }
    }
  });

  score = (+totalCorrectAnswer / +actualAnswer.length).toFixed(2);

  if (attempted && loggedInState.rolesInfo.title.toLowerCase() == "learner") {
    genericScore = calculateGenericScore(
      currentAttempt,
      numberOfAttemptes,
      score
    ).toFixed(2);
    commitUserAnswerInStore(userAnswer, genericScore, currentAttempt);
  } else {
    genericScore = 1;
  }

  return {
    totalOptions: actualAnswer.length,
    totalCorrectAnswer,
    score,
    attempted,
    genericScore,
    evalMode,
    optionWiseAns,
  };
};

export const checkJWCorrectAnswer = (
  userAnswer,
  actualAnswer,
  currentAttempt,
  numberOfAttemptes,
  assetType,
  evalMode
) => {
  let totalCorrectAnswer = 0;
  let score = 0;
  let genericScore = 0;
  let attempted = false;
  let optionWiseAns = new Array(actualAnswer.length).fill(false);

  if (
    userAnswer !== null &&
    userAnswer.length > 0 &&
    userAnswer[0].length > 0
  ) {
    attempted = true;
  }

  actualAnswer.map((val, index) => {
    if (
      userAnswer &&
      userAnswer[index] &&
      val &&
      val.trim() == userAnswer[index].trim()
    ) {
      totalCorrectAnswer++;
      optionWiseAns[index] = true;
    }
  });

  score = (+totalCorrectAnswer / +actualAnswer.length).toFixed(2);

  if (attempted && loggedInState.rolesInfo.title.toLowerCase() == "learner") {
    genericScore = calculateGenericScore(
      currentAttempt,
      numberOfAttemptes,
      score
    ).toFixed(2);
    commitUserAnswerInStore(userAnswer, genericScore, currentAttempt);
  } else {
    genericScore = 1;
  }

  return {
    totalOptions: actualAnswer.length,
    totalCorrectAnswer,
    score,
    attempted,
    genericScore,
    evalMode,
    optionWiseAns,
  };
};

export const checkDICCorrectAnswer = (
  userAnswer,
  actualAnswer,
  currentAttempt,
  numberOfAttemptes,
  assetType,
  evalMode
) => {
  let totalAttemptedOptions = 0;
  let totalCorrectAnswer = 0;
  let score = 0;
  let genericScore = 0;
  let attempted = false;
  let optionWiseAns = new Array(userAnswer.length).fill();

  actualAnswer.map((val, index) => {
    if (userAnswer && userAnswer[index] && userAnswer[index][0]) {
      totalAttemptedOptions++;
      if (val && val[0] && val.indexOf(userAnswer[index][0].trim()) != -1) {
        totalCorrectAnswer++;
        optionWiseAns[index] = true;
      } else {
        optionWiseAns[index] = false;
      }
    }
  });

  if (+totalAttemptedOptions == +actualAnswer.length) {
    attempted = true;
  }

  if (evalMode == "auto") {
    if (totalCorrectAnswer) {
      score = (+totalCorrectAnswer / +totalAttemptedOptions).toFixed(2);
    }

    if (attempted && loggedInState.rolesInfo.title.toLowerCase() == "learner") {
      genericScore = calculateGenericScore(
        currentAttempt,
        numberOfAttemptes,
        score
      ).toFixed(2);
      commitUserAnswerInStore(userAnswer, genericScore, currentAttempt);
    } else {
      genericScore = 1;
    }
  } else {
    commitUserAnswerInStore(userAnswer, 0, 1, "manual");
  }

  return {
    totalOptions: actualAnswer.length,
    totalCorrectAnswer,
    score,
    attempted,
    genericScore,
    evalMode,
    optionWiseAns,
  };
};

export const checkSFCorrectAnswer = (
  userAnswer,
  actualAnswer,
  currentAttempt,
  numberOfAttemptes,
  assetType,
  evalMode
) => {
  let totalCorrectAnswer = 0;
  let score = 0;
  let genericScore = 0;
  let attempted = false;
  let optionWiseAns = new Array(actualAnswer.length).fill();
  if (
    userAnswer !== null &&
    userAnswer.length > 0 &&
    userAnswer[0].length > 0
  ) {
    attempted = true;
  }

  let actualAns = actualAnswer.map((val, index) => {
    return unicodeToString(val).split(" ").join("");
  });
  actualAns.map((val, index) => {
    if (
      userAnswer &&
      userAnswer[index] &&
      val &&
      actualAns.indexOf(userAnswer[index].join("").trim()) != -1
    ) {
      totalCorrectAnswer++;
      optionWiseAns[index] = true;
    } else {
      optionWiseAns[index] = false;
    }
  });

  score = (+totalCorrectAnswer / +actualAnswer.length).toFixed(2);

  if (attempted && loggedInState.rolesInfo.title.toLowerCase() == "learner") {
    genericScore = calculateGenericScore(
      currentAttempt,
      numberOfAttemptes,
      score
    ).toFixed(2);
    commitUserAnswerInStore(userAnswer, genericScore, currentAttempt);
  } else {
    genericScore = 1;
  }

  return {
    totalOptions: actualAnswer.length,
    totalCorrectAnswer,
    score,
    attempted,
    genericScore,
    evalMode,
    optionWiseAns,
  };
};

export const checkFIBCorrectAnswer = (
  userAnswer,
  actualAnswer,
  currentAttempt,
  numberOfAttemptes,
  assetType,
  evalMode
) => {
  let totalBlanks = 0;
  let totalAttemptedBlanks = 0;
  let totalCorrectAnswer = 0;
  let score = 0;
  let genericScore = 0;
  let attempted = false;
  let optionWiseAns = [];

  console.log("userAnswer0303", userAnswer);
  userAnswer.map((val, index) => {
    if (val && Array.isArray(val)) {
      let innerVal = new Array(val.length);
      optionWiseAns.push(innerVal);
      val.map((valInner, index1) => {
        console.log("valInner", valInner);
        totalBlanks++;
        // if (valInner && valInner.length > 0 && !attempted) {
        //   attempted = true;
        // }
        if (valInner && !Array.isArray(valInner)) {
          if (valInner.trim().length > 0) {
            totalAttemptedBlanks++;
          }
          if (actualAnswer[index][index1].indexOf(valInner.trim()) != -1) {
            totalCorrectAnswer++;
            optionWiseAns[index][index1] = true;
          } else {
            optionWiseAns[index][index1] = false;
          }
        }
        if (valInner && Array.isArray(valInner) && valInner[0]) {
          if (valInner[0].trim().length > 0) {
            totalAttemptedBlanks++;
          }
          if (actualAnswer[index][index1].indexOf(valInner[0].trim()) != -1) {
            totalCorrectAnswer++;
            optionWiseAns[index][index1] = true;
          } else {
            optionWiseAns[index][index1] = false;
          }
        }
      });
    }
  });

  console.log("FIB", totalCorrectAnswer);
  if (+totalAttemptedBlanks == +totalBlanks) {
    attempted = true;
  } else {
    attempted = false;
  }

  // if (evalMode == "auto") {
  if (totalCorrectAnswer) {
    score = (+totalCorrectAnswer / +totalBlanks).toFixed(2);
  }

  if (attempted && loggedInState.rolesInfo.title.toLowerCase() == "learner") {
    genericScore = calculateGenericScore(
      currentAttempt,
      numberOfAttemptes,
      score
    ).toFixed(2);
    commitUserAnswerInStore(userAnswer, genericScore, currentAttempt);
  } else {
    genericScore = 1;
  }
  // } else {
  //   commitUserAnswerInStore(userAnswer, 0, 1, "manual");
  // }

  return {
    totalOptions: totalBlanks,
    totalCorrectAnswer,
    score,
    attempted,
    genericScore,
    evalMode,
    optionWiseAns,
  };
};

export const checkRECCorrectAnswer = async (
  userAnswer,
  actualAnswer,
  currentAttempt,
  numberOfAttemptes,
  assetType,
  evalMode
) => {
  let totalAttemptedOptions = 0;
  let totalCorrectAnswer = 0;
  let score = 0;
  let genericScore = 0;
  let attempted = false;
  let newUserAnswers = [];
  const { smartCheck: analysis, aiEnable } = Store.getState().currentAsset;
  const serverRole = Store.getState().defs.serverRole;
  console.log("userAnswer", aiEnable);

  actualAnswer.map(async (val, index) => {
    if (userAnswer && userAnswer[index]) {
      totalAttemptedOptions++;
      console.log("SSSSGGGGGHanalysis[index]", analysis[index]);
      if (analysis[index]) {
        score += analysis[index]["utterance"]
          ? analysis[index]["utterance"][0]["nativeness_score"]
          : analysis[index]["speakers"][0]?.metrics?.general_scores?.elsa
              ?.eps_score;
      }
    }
  });
  console.log("LuserAnsweruserAnsweruserAnswer", userAnswer);
  if (+totalAttemptedOptions == +userAnswer.length) {
    attempted = true;
  }
  score = (+score / +actualAnswer.length / 100).toFixed(2);

  if (!aiEnable) {
    score = 1;
  }

  if (attempted && loggedInState.rolesInfo.title.toLowerCase() == "learner") {
    genericScore = calculateGenericScore(
      currentAttempt,
      numberOfAttemptes,
      score
    ).toFixed(2);
    commitUserAnswerInStore(
      userAnswer,
      genericScore,
      currentAttempt,
      "auto",
      assetType
    );
  } else {
    genericScore = 1;
  }

  return {
    totalOptions: actualAnswer.length,
    totalCorrectAnswer,
    score,
    attempted,
    genericScore:
      serverRole && serverRole.toLowerCase() == "WEB_HOST" ? genericScore : 1,
    evalMode,
  };
};

export const checkSBCorrectAnswer = (
  userAnswer,
  actualAnswer,
  currentAttempt,
  numberOfAttemptes,
  assetType,
  evalMode
) => {
  let totalCorrectAnswer = 0;
  let score = 0;
  let genericScore = 0;
  let attempted = false;
  let optionWiseAns = new Array(actualAnswer.length).fill();
  let ac = actualAnswer[0].slice().sort((a, b) => b - a);

  actualAnswer.map((val, index) => {
    let actualSort = val.slice().sort((a, b) => b - a);
    let userSort = userAnswer[index].slice().sort((a, b) => b - a);
    if (index == 0) {
      attempted = true;
    }
    if (userAnswer[index].length == 0) {
      attempted = false;
    }
    if (actualSort.join(",") == userSort.join(",")) {
      totalCorrectAnswer++;
      optionWiseAns[index] = true;
    } else {
      optionWiseAns[index] = false;
    }
  });

  score = (+totalCorrectAnswer / +actualAnswer.length).toFixed(2);

  if (attempted && loggedInState.rolesInfo.title.toLowerCase() == "learner") {
    genericScore = calculateGenericScore(
      currentAttempt,
      numberOfAttemptes,
      score
    ).toFixed(2);
    commitUserAnswerInStore(userAnswer, genericScore, currentAttempt);
  } else {
    genericScore = 1;
  }

  return {
    totalOptions: actualAnswer.length,
    totalCorrectAnswer,
    score,
    attempted,
    genericScore,
    evalMode,
    optionWiseAns,
  };
};

export const checkOOCorrectAnswer = (
  userAnswer,
  actualAnswer,
  currentAttempt,
  numberOfAttemptes,
  assetType,
  evalMode
) => {
  let totalCorrectAnswer = new Array(actualAnswer.length).fill(0);
  let score = 0;
  let genericScore = 0;
  let attempted = false;
  let optionWiseAns = new Array(actualAnswer.length).fill(false);

  for (let ind = 0; ind < userAnswer.length; ind++) {
    if (userAnswer[ind].length > 0) {
      attempted = true;
    }
    if (userAnswer[ind].length == 0) {
      attempted = false;
      break;
    }
  }

  actualAnswer.map((val, index) => {
    val.map((val1, index1) => {
      if (
        userAnswer &&
        userAnswer[index] &&
        userAnswer[index].indexOf(val1) > -1
      ) {
        totalCorrectAnswer[index]++;
      }
    });
  });

  actualAnswer.map((ans, index) => {
    let tempScore = 0;
    if (userAnswer[index] && userAnswer[index].length > ans.length) {
      tempScore = (
        +totalCorrectAnswer[index] / +userAnswer[index].length
      ).toFixed(2);
    } else {
      tempScore = (+totalCorrectAnswer[index] / +ans.length).toFixed(2);
    }
    if (tempScore == 1) {
      optionWiseAns[index] = true;
    }
    score = +score + +tempScore;
  });

  score = (+score / +actualAnswer.length).toFixed(2);

  if (attempted && loggedInState.rolesInfo.title.toLowerCase() == "learner") {
    genericScore = calculateGenericScore(
      currentAttempt,
      numberOfAttemptes,
      score
    ).toFixed(2);
    commitUserAnswerInStore(userAnswer, genericScore, currentAttempt);
  } else {
    genericScore = 1;
  }

  return {
    totalOptions: actualAnswer.length,
    totalCorrectAnswer,
    score,
    attempted,
    genericScore,
    evalMode,
    optionWiseAns,
  };
};

export const checkWSCorrectAnswer = (
  userAnswer,
  actualAnswer,
  currentAttempt,
  numberOfAttemptes,
  assetType,
  evalMode
) => {
  let totalCorrectAnswer = 0;
  let score = 0;
  let genericScore = 0;
  let attempted = false;
  if (userAnswer.length == actualAnswer.length) {
    attempted = true;
  }
  userAnswer.map((val, index) => {
    score += +val.score;
  });

  if (attempted && loggedInState.rolesInfo.title.toLowerCase() == "learner") {
    genericScore = (+score / +userAnswer.length).toFixed(2);
    commitUserAnswerInStore(userAnswer, genericScore, currentAttempt);
  } else {
    genericScore = 1;
  }

  return {
    totalOptions: actualAnswer.length,
    totalCorrectAnswer: userAnswer.length,
    score: 1,
    attempted,
    genericScore,
    evalMode,
  };
};

export const checkTFSCorrectAnswer = (
  userAnswer,
  actualAnswer,
  currentAttempt,
  numberOfAttemptes,
  assetType,
  evalMode
) => {
  let totalTrueOptionsOfUseranswer = 0;
  let totalTrueOptionsOfActualanswer = 0;
  let totalCorrectAnswer = 0;
  let totalAttemptedOpt = 0;
  let score = 0;
  let genericScore = 0;
  let attempted = false;
  let optionWiseAns = new Array(actualAnswer.length).fill();

  actualAnswer.map((val, index) => {
    if (val && userAnswer && userAnswer[index] && val == userAnswer[index]) {
      totalCorrectAnswer++;
      optionWiseAns[index] = true;
    } else {
      optionWiseAns[index] = false;
    }
    if (userAnswer[index]) {
      totalAttemptedOpt++;
    }
  });

  if (+totalAttemptedOpt == +actualAnswer.length) {
    attempted = true;
  } else {
    attempted = false;
  }

  if (totalCorrectAnswer) {
    score = (+totalCorrectAnswer / +actualAnswer.length).toFixed(2);
  }

  if (attempted && loggedInState.rolesInfo.title.toLowerCase() == "learner") {
    genericScore = calculateGenericScore(
      currentAttempt,
      numberOfAttemptes,
      score
    ).toFixed(2);
    commitUserAnswerInStore(userAnswer, genericScore, currentAttempt);
  } else {
    genericScore = 1;
  }

  return {
    totalOptions: actualAnswer.length,
    totalCorrectAnswer,
    score,
    attempted,
    genericScore,
    evalMode,
    optionWiseAns,
  };
};

export const checkIECorrectAnswer = (
  userAnswer,
  actualAnswer,
  currentAttempt,
  numberOfAttemptes,
  assetType,
  evalMode
) => {
  let totalTrueOptionsOfUseranswer = 0;
  let totalTrueOptionsOfActualanswer = 0;
  let totalCorrectAnswer = 0;
  let totalAttemptedOpt = 0;
  let score = 0;
  let genericScore = 0;
  let attempted = false;
  let optionWiseAns = new Array(actualAnswer.length).fill();

  actualAnswer.map((val, index) => {
    if (
      val &&
      userAnswer &&
      userAnswer[index] &&
      val.indexOf(userAnswer[index].trim()) > -1
    ) {
      totalCorrectAnswer++;
      optionWiseAns[index] = true;
    } else {
      optionWiseAns[index] = false;
    }
    if (userAnswer[index]) {
      totalAttemptedOpt++;
    }
  });

  if (totalCorrectAnswer) {
    score = (+totalCorrectAnswer / +actualAnswer.length).toFixed(2);
  }

  if (+totalAttemptedOpt == +actualAnswer.length) {
    attempted = true;
  } else {
    attempted = false;
  }

  if (attempted && loggedInState.rolesInfo.title.toLowerCase() == "learner") {
    genericScore = calculateGenericScore(
      currentAttempt,
      numberOfAttemptes,
      score
    ).toFixed(2);
    commitUserAnswerInStore(userAnswer, genericScore, currentAttempt);
  } else {
    genericScore = 1;
  }

  return {
    totalOptions: actualAnswer.length,
    totalCorrectAnswer,
    score,
    attempted,
    genericScore,
    evalMode,
    optionWiseAns,
  };
};

export const checkNBCorrectAnswer = (
  userAnswer,
  actualAnswer,
  currentAttempt,
  numberOfAttemptes,
  assetType,
  evalMode
) => {
  let totalAttemptedOptions = 0;
  let totalCorrectAnswer = 0;
  let score = 0;
  let genericScore = 0;
  let attempted = false;

  userAnswer.map((val, index) => {
    console.log("val", val);
    if (val && val[0]["text1"]) {
      totalAttemptedOptions++;
    }
  });

  if (+totalAttemptedOptions == +userAnswer.length) {
    attempted = true;
  }

  commitUserAnswerInStore(userAnswer, 0, 1, "manual");

  return {
    totalOptions: userAnswer.length,
    totalCorrectAnswer,
    score,
    attempted,
    genericScore,
    evalMode,
  };
};

export const checkTHESAURUSorWORDGROUPCorrectAnswer = (
  userAnswer,
  actualAnswer,
  currentAttempt,
  numberOfAttemptes,
  assetType,
  evalMode
) => {
  let totalTrueOptionsOfUseranswer = 0;
  let totalTrueOptionsOfActualanswer = 0;
  let totalCorrectAnswer = 0;
  let score = 0;
  let genericScore = 0;
  let attempted = false;
  let optionWiseAns = [];

  actualAnswer.map((val, index) => {
    let trueAns, lengthAns;

    let innerVal = new Array(userAnswer[index]);
    optionWiseAns.push(innerVal);

    if (assetType == "THESAURUS") {
      trueAns = intersection(val, userAnswer[index]);
      userAnswer[index].map((wrd, wrdIndex) => {
        if (val.indexOf(wrd) > -1) {
          optionWiseAns[index][wrdIndex] = true;
        } else {
          optionWiseAns[index][wrdIndex] = false;
        }
      });
      lengthAns = countBy(userAnswer[index], "length");
      if (lengthAns[0]) {
        lengthAns = lengthAns[0];
      } else {
        lengthAns = 0;
      }
    }
    if (assetType == "WORDGROUP") {
      userAnswer[index].map((wrd, wrdIndex) => {
        if (val.indexOf(wrd.item.uid) > -1) {
          optionWiseAns[index][wrdIndex] = true;
        } else {
          optionWiseAns[index][wrdIndex] = false;
        }
      });

      trueAns = intersection(
        val,
        map(userAnswer[index], (o) => {
          return o.item.uid;
        })
      );
    }

    console.log("trueAns", trueAns);

    if (
      val &&
      userAnswer &&
      userAnswer[index] &&
      userAnswer[index].length > 0 &&
      trueAns.length > 0
    ) {
      if (
        assetType == "THESAURUS" &&
        trueAns.length == userAnswer[index].length
      ) {
        totalCorrectAnswer++;
      }
      if (assetType == "WORDGROUP" && trueAns.length == val.length) {
        totalCorrectAnswer++;
      }

      if (assetType == "THESAURUS") {
        score += +trueAns.length / +userAnswer[index].length;
      }
      if (assetType == "WORDGROUP") {
        score += +trueAns.length / +val.length;
      }
    }

    if (
      assetType == "THESAURUS" &&
      lengthAns != userAnswer[index].length &&
      !attempted
    ) {
      attempted = true;
    }
    if (
      assetType == "WORDGROUP" &&
      userAnswer[index].length > 0 &&
      !attempted
    ) {
      attempted = true;
    }
  });

  score = +score / +actualAnswer.length;

  if (attempted && loggedInState.rolesInfo.title.toLowerCase() == "learner") {
    genericScore = calculateGenericScore(
      currentAttempt,
      numberOfAttemptes,
      score
    ).toFixed(2);
    commitUserAnswerInStore(userAnswer, genericScore, currentAttempt);
  } else {
    genericScore = 1;
  }

  return {
    totalOptions: actualAnswer.length,
    totalCorrectAnswer,
    score,
    attempted,
    genericScore,
    evalMode,
    optionWiseAns,
  };
};

export const checkBINGOCorrectAnswer = (
  userAnswer,
  actualAnswer,
  currentAttempt,
  numberOfAttemptes,
  assetType,
  evalMode
) => {
  let totalCorrectAnswer = 0;
  let score = 0;
  let genericScore = 0;
  let attempted = false;
  let bingoMin = Store.getState().currentAsset.bingoMin;
  console.log("userAnswer", userAnswer);
  if (userAnswer && userAnswer?.userans?.length >= +bingoMin) {
    attempted = true;
    score = userAnswer.correctAns / actualAnswer.length;
  }

  if (attempted && loggedInState.rolesInfo.title.toLowerCase() == "learner") {
    genericScore = score.toFixed(2);
    commitUserAnswerInStore(userAnswer, genericScore, currentAttempt);
  } else {
    genericScore = 1;
  }

  return {
    totalOptions: actualAnswer.length,
    totalCorrectAnswer,
    score: 1,
    attempted,
    genericScore,
    evalMode,
  };
};

export const checkSBCorrectAnswerPresentation = (
  userAnswer,
  actualAnswer,
  mainIndex
) => {
  let totalCorrectAnswer = 0;
  let score = 0;
  let genericScore = 0;
  let attempted = false;
  //let optionWiseAns = new Array(actualAnswer.length).fill();
  //actualAnswer = [actualAnswer[mainIndex]];
  //userAnswer = [actualAnswer[mainIndex]];
  console.log("&&&&&&&&&&&", actualAnswer);
  console.log("&&&&&&&&&&&111111", userAnswer);
  let actAns = [...actualAnswer];
  let useAns = [...userAnswer];
  let actualSort = actAns.sort();
  let userSort = useAns.sort();
  if (userAnswer && userAnswer.length > 0) {
    attempted = true;
  }
  if (userAnswer && userAnswer.length == 0) {
    attempted = false;
  }
  if (actualSort.join(",") == userSort.join(",")) {
    totalCorrectAnswer++;
    //optionWiseAns[index] = true;
  } else {
    //optionWiseAns[index] = false;
  }

  score = (+totalCorrectAnswer / 1).toFixed(2);

  // if (attempted && loggedInState.rolesInfo.title.toLowerCase() == "learner") {
  //   commitUserAnswerInStore(userAnswer, 1, currentAttempt);
  // } else {
  genericScore = 1;
  //}

  return {
    totalOptions: actualAnswer.length,
    totalCorrectAnswer,
    score,
    attempted,
    genericScore,
  };
};

export const checkILTCorrectAnswer = (
  userAnswer,
  actualAnswer,
  currentAttempt,
  numberOfAttemptes,
  assetType,
  evalMode
) => {
  let totalCorrectAnswer = 1;
  let score = 1;
  let genericScore = 1;
  let attempted = true;

  if (attempted && loggedInState.rolesInfo.title.toLowerCase() == "learner") {
    commitUserAnswerInStore([], 1, 1);
  } else {
    genericScore = 1;
  }

  return {
    totalOptions: 1,
    totalCorrectAnswer,
    score,
    attempted,
    genericScore,
  };
};

export const checkMEDIACorrectAnswer = (
  userAnswer,
  actualAnswer,
  currentAttempt,
  numberOfAttemptes,
  assetType,
  evalMode
) => {
  let totalCorrectAnswer = 1;
  let score = 1;
  let genericScore = 1;
  let attempted = true;

  if (attempted && loggedInState.rolesInfo.title.toLowerCase() == "learner") {
    commitUserAnswerInStore([], 1, 1);
  } else {
    genericScore = 1;
  }

  return {
    totalOptions: 1,
    totalCorrectAnswer,
    score,
    attempted,
    genericScore,
  };
};

export const checkRECADVCorrectAnswer = async (
  userAnswer,
  actualAnswer,
  currentAttempt,
  numberOfAttemptes,
  assetType,
  evalMode
) => {
  let totalAttemptedOptions = 0;
  let totalCorrectAnswer = 0;
  let score = 0;
  let genericScore = 0;
  let attempted = false;
  let newUserAnswers = [];
  const { aiEnable, smartAdvCheck } = Store.getState().currentAsset;
  const serverRole = Store.getState().defs.serverRole;

  actualAnswer.map(async (val, index) => {
    if (userAnswer && userAnswer[index]) {
      totalAttemptedOptions++;
      let optionScore = 0;
      if (smartAdvCheck[index]) {
        smartAdvCheck[index].map((valResult) => {
          let innerScore = 0;
          valResult.result.map((innerRes) => {
            if (innerRes && innerRes.result) {
              innerScore = innerScore + 1;
            }
          });

          optionScore =
            optionScore + +(+innerScore / +valResult.result.length).toFixed(2);
        });
        optionScore = +(+optionScore / +smartAdvCheck[index].length).toFixed(2);
      }
      score = score + optionScore;
    }
  });
  console.log("LuserAnsweruserAnsweruserAnswer", userAnswer);
  if (+totalAttemptedOptions == +userAnswer.length) {
    attempted = true;
  }
  score = (+score / +actualAnswer.length).toFixed(2);

  if (!aiEnable) {
    score = 1;
  }

  if (attempted && loggedInState.rolesInfo.title.toLowerCase() == "learner") {
    genericScore = calculateGenericScore(
      currentAttempt,
      numberOfAttemptes,
      score
    ).toFixed(2);
    commitUserAnswerInStore(
      userAnswer,
      genericScore,
      currentAttempt,
      "auto",
      assetType
    );
  } else {
    genericScore = 1;
  }

  return {
    totalOptions: actualAnswer.length,
    totalCorrectAnswer,
    score,
    attempted,
    genericScore:
      serverRole && serverRole.toLowerCase() == "WEB_HOST" ? genericScore : 1,
    evalMode,
  };
};
